/**
 * 退供相关路由
 */
export default [
  {
    // 退供单列表
    path: "returnOrder/returnOrderList",
    name: "ReturnOrderList",
    component: () => import("../pages/returnOrder/returnOrderList.vue"),
    meta: {
      title: "前置仓退供单",
    },
  },
  {
    // 创建/编辑退供单
    path: "returnOrder/returnOrderEdit/:return_order_id",
    name: "ReturnOrderEdit",
    component: () => import("../pages/returnOrder/returnOrderEdit.vue"),
    meta: {
      title: "编辑退供单",
    },
  },
  {
    // 退供单详情
    path: "returnOrder/returnOrderDetail/:return_order_id",
    name: "ReturnOrderDetail",
    component: () => import("../pages/returnOrder/returnOrderDetail.vue"),
    meta: {
      title: "退供单详情",
    },
  },
  {
    // 退供单拣货列表
    path: "returnOrder/returnOrderTaskList",
    name: "ReturnOrderTaskList",
    component: () => import("../pages/returnOrder/returnOrderTaskList.vue"),
    meta: {
      title: "退供单拣货任务",
    },
  },
  {
    // 退供单拣货详情列表
    path: "returnOrder/returnOrderTaskDetail/:return_order_task_id",
    name: "ReturnOrderTaskDetail",
    component: () => import("../pages/returnOrder/returnOrderTaskDetail.vue"),
    meta: {
      title: "拣货任务明细",
    },
  },
  {
    // 退供包裹列表
    path: "returnOrder/returnOrderPackageList",
    name: "ReturnOrderPackageList",
    component: () => import("../pages/returnOrder/returnOrderPackageList.vue"),
    meta: {
      title: "退供包裹列表",
    },
  },
  {
    // 退供包裹明细
    path: "returnOrder/returnOrderPackageDetail/:return_order_package_id",
    name: "ReturnOrderPackageDetail",
    component: () =>
      import("../pages/returnOrder/returnOrderPackageDetail.vue"),
    meta: {
      title: "退供包裹明细",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/returnOrder.js